export default class AccessType {
    code: string;

    name: string;

    description: string;

    constructor(_code: string,
      _name: string,
      _description: string) {
      this.code = _code;
      this.name = _name;
      this.description = _description;
    }

    static readonly publicType = new AccessType('public', 'Public', '');

    static readonly privateType = new AccessType('private', 'Private', '');

    static readonly organizationType = new AccessType('organization', 'Organization', '');

    static readonly campaignAddType = new AccessType('campaignAdd', 'campaignAdd', '');
}
